var map = {
	"./BPT.png": 578,
	"./LIFT-LP.png": 579,
	"./LIFT.png": 580,
	"./M2-BPT.png": 581,
	"./M2.png": 582,
	"./PIXEL-BPT.png": 583,
	"./PIXEL-LP.png": 584,
	"./PIXEL.png": 585,
	"./SEEDZ.png": 586,
	"./STR-BPT.png": 587,
	"./STR-LP.png": 588,
	"./STR.png": 589,
	"./UNI-v2.png": 590,
	"./USD_Coin_icon.webp": 1494,
	"./WBTC.png": 591,
	"./WPE.png": 592,
	"./YFU-BPT.png": 593,
	"./YFU-LP.png": 594,
	"./YFU.png": 595,
	"./dai-multi-collateral-mcd.webp": 1495,
	"./logo-eth.png": 596,
	"./logo-mkr.png": 597,
	"./logo-perp.png": 598,
	"./opes-logo-big.png": 599,
	"./tether_32.webp": 1496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 139;